import React from 'react';

const InstagramIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      id="instagram"
      aria-label="Instagram"
    >
      <linearGradient
        id="a"
        x1="1.464"
        x2="12.136"
        y1="1.464"
        y2="1.464"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFC107" />
        <stop offset=".507" stopColor="#F44336" />
        <stop offset=".99" stopColor="#9C27B0" />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M 11 0 H 5 a 5 5 0 0 0 -5 5 v 6 a 5 5 0 0 0 5 5 h 6 a 5 5 0 0 0 5 -5 V 5 a 5 5 0 0 0 -5 -5 Z m 3.5 11 c 0 1.93 -1.57 3.5 -3.5 3.5 H 5 c -1.93 0 -3.5 -1.57 -3.5 -3.5 V 5 c 0 -1.93 1.57 -3.5 3.5 -3.5 h 6 c 1.93 0 3.5 1.57 3.5 3.5 v 6 Z" 
      />
      <linearGradient
        id="b"
        x1="5.172"
        x2="10.828"
        y1="10.828"
        y2="5.172"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFC107" />
        <stop offset=".507" stopColor="#F44336" />
        <stop offset=".99" stopColor="#9C27B0" />
      </linearGradient>
      <path
        fill="url(#b)"
        d="M 8 4 a 4 4 0 1 0 0 8 a 4 4 0 0 0 0 -8 Z m 0 6.5 A 2.503 2.503 0 0 1 5.5 8 c 0 -1.379 1.122 -2.5 2.5 -2.5 s 2.5 1.121 2.5 2.5 c 0 1.378 -1.122 2.5 -2.5 2.5 Z"
      />
      <linearGradient
        id="c"
        x1="11.923"
        x2="12.677"
        y1="4.077"
        y2="3.323"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFC107" />
        <stop offset=".507" stopColor="#F44336" />
        <stop offset=".99" stopColor="#9C27B0" />
      </linearGradient>
      <circle cx="12.3" cy="3.7" r="0.53" fill="url(#c)" />
    </svg>
  );
};

export default InstagramIcon;
